import React from "react";
import Chart from "chart.js/auto";

class PieChart extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidUpdate() {
    this.myChart.data = this.props.data;
    this.myChart.update();
  }

  componentDidMount() {
    Chart.defaults.font.size = 15;
    this.myChart = new Chart(this.canvasRef.current, {
      type: "doughnut",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2.6,

        plugins: {
          legend: {
            position: "left",
            labels: {
              padding: 10,
            },
            onHover: function (e) {
              e.native.target.style.cursor = "pointer";
            },
            onLeave: function (e) {
              e.native.target.style.cursor = "default";
            },
          },
        },
        layout: { padding: 0 },

        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var meta = dataset._meta[Object.keys(dataset._meta)[0]];
              var total = meta.total;
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = parseFloat(
                ((currentValue / total) * 100).toFixed(1)
              );
              return " " + currentValue + " findings (" + percentage + "%)";
            },
            title: function (tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            },
          },
        },
      },

      data: this.props.data,
    });
  }

  render() {
    return <canvas ref={this.canvasRef} height='250px' />;
  }
}

export default PieChart;
